import types from './constant';

export const setDialogState = data => ({
  type: types.NO_PERMISSION_DIALOG_SET_STATE,
  payload: data
});
